import { render, staticRenderFns } from "./gameAnalysis.vue?vue&type=template&id=573279d0&scoped=true"
import script from "./gameAnalysis.vue?vue&type=script&lang=js"
export * from "./gameAnalysis.vue?vue&type=script&lang=js"
import style0 from "./gameAnalysis.vue?vue&type=style&index=0&id=573279d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573279d0",
  null
  
)

export default component.exports